/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetProfileInfoRequest} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'
import {GetProfileInfoResponse} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'


export const getProfileInfoCashDotApp = (request: GetProfileInfoRequest, options?: CashRequestOptions) => post<GetProfileInfoRequest, GetProfileInfoResponse>("/2.0/cash/get-profile-info-cash-dot-app", request, {...options, rejectOnError: true })